module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/2-61fae0f2e2ace18f7004733f8e8b857d.webp";